import React from 'react';

import Reservation2 from 'app/components/icons/Reservation2';
import ReservationDetail, {
  ReservationDetailProps,
} from 'app/components/ReservationSummary/ReservationDetail';
import TextLabel from 'app/components/ReservationSummary/TextLabel';
import { time } from 'app/services/ReservationHelper';
import { tID } from 'app/services/TestHelper';

export type ReservationDetailTimeProps = Omit<ReservationDetailProps, 'Icon'> & {
  dateTime: string | undefined;
  ianaTimezone: string | undefined;
  isMuted?: boolean;
  label?: string;
};

export default function ReservationDetailTime({
  dateTime,
  ianaTimezone,
  isMuted = false,
  label,
  ...props
}: ReservationDetailTimeProps) {
  const $time = dateTime ? time(dateTime, ianaTimezone) : null;

  return (
    <ReservationDetail Icon={Reservation2} testID={tID('ReservationDetailTime')} {...props}>
      <TextLabel isMuted={isMuted}>
        {$time ? $time.format(label ? 'h:mm A' : 'hh:mm') : ''}
      </TextLabel>
      <TextLabel isMuted={isMuted}>{$time ? label || $time.format('A z') : ''}</TextLabel>
    </ReservationDetail>
  );
}
